export const pdfActionLimiter = ({
  itemNumber,
  maxItem,
  minItem
}: { itemNumber: number, minItem: number, maxItem: number }) => {
  if (itemNumber >= maxItem) return maxItem;
  if (itemNumber <= minItem) return minItem;
  return itemNumber
}
